import { render, staticRenderFns } from "./InputNumero.vue?vue&type=template&id=4dcd5948"
import script from "./InputNumero.vue?vue&type=script&lang=js"
export * from "./InputNumero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports